<template>
  <div class="mux-video-provider">
    <MuxAttendeeVideoPlayer 
      v-bind:videoAsset="videoAsset"
      v-bind:eventAttendee="eventAttendee"
      v-bind:customEventAttendeeId="customEventAttendeeId"
      v-if="videoAsset"
    />
  </div>
</template>

<script>
import axios from 'axios'
import MuxAttendeeVideoPlayer from './MuxAttendeeVideoPlayer'
import { BSpinner } from 'bootstrap-vue'
export default {
  components: {
    MuxAttendeeVideoPlayer,
    BSpinner
  },
  props: {
    videoAssetId: {
      type: String|Number,
      required: true
    },
    customEventAttendeeId: {
      type: String|Number,
      default: null
    }
  },

  data: function () {
    return {
      videoAsset: null,
      fetchingVideoAsset: false,
      eventAttendee: null
    }
  },

  methods: {
    fetchVideoAsset () {
      this.fetchingVideoAsset = true
      axios.get(`/api/v1/video-assets/${this.videoAssetId}`,{
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        }
      }).then(function (response) {
        console.log(response.data)
        this.videoAsset = response.data.video_asset
        this.eventAttendee = response.data.event_attendee
      }.bind(this))
      .catch(function (err) {
        console.log(err)
      }.bind(this))
      .then(function() {
        this.fetchingVideoAsset = false
      }.bind(this))
    }
  },

  mounted: function () {
    this.fetchVideoAsset()
  }
}
</script>
